export const Logo = ({ size = 40 }) => (
    <a
        href="#top"
        onClick={(e) => {
            e.preventDefault();
            const lenis = window.__lenis;
            if (lenis) lenis.scrollTo(0, { duration: 1.1 });
            else window.scrollTo({ top: 0, behavior: "smooth" });
        }}
        className="flex items-center gap-3 group"
        data-testid="logo-link"
        aria-label="Cash For Cars — home"
    >
        <span
            className="grid place-items-center rounded-xl bg-volt shadow-[0_0_24px_rgba(212,255,0,0.35)] transition-transform duration-300 group-hover:rotate-6 group-hover:scale-105"
            style={{ width: size, height: size }}
        >
            <svg viewBox="0 0 48 48" width={size * 0.62} height={size * 0.62} aria-hidden="true">
                <path d="M27 6 12.5 26.5h9.2L18 42l17.5-21.5h-10L27 6z" fill="#08090C" />
            </svg>
        </span>
        <span className="leading-none">
            <span className="block font-display text-lg sm:text-xl font-black tracking-tight text-white">
                CASH FOR CARS
            </span>
            <span className="block text-[10px] font-bold uppercase tracking-[0.28em] text-volt mt-1">
                Houston, TX
            </span>
        </span>
    </a>
);
